import * as React from 'react';
import { FormControlLabel } from '@mui/material';
import cn from 'classnames';
import { Checkbox } from '../../../../../BaseComponents';
import { useTheme } from '../../../../../theme';
const ExchangeRefundSelectControl = ({ className, classes, label, isSelected, isDisabled, onChange }) => {
    const { ExchangeRefundSelectControl: theme } = useTheme('Entities').Order;
    const onChangeHandler = (_, checked) => {
        onChange(checked);
    };
    return (React.createElement(FormControlLabel, { className: className, disabled: isDisabled, classes: Object.assign(Object.assign({}, classes), { root: cn(theme.root, classes === null || classes === void 0 ? void 0 : classes.root, {
                [theme.root_checked]: isSelected,
                [theme.root_disabled]: isDisabled
            }), label: cn(theme.label, classes === null || classes === void 0 ? void 0 : classes.label) }), control: React.createElement(Checkbox, { checked: isSelected, disabled: isDisabled, onChange: onChangeHandler }), label: label }));
};
export default ExchangeRefundSelectControl;
